import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ServiceIcon from "@mui/icons-material/Rule";
import EmailIcon from "@mui/icons-material/Email";  
import OrdersIcon from "@mui/icons-material/ShoppingCart";
import OrderTypeIcon from "@mui/icons-material/MergeType";
import OrderStateIcon from "@mui/icons-material/FilterAlt";

import { useNavigate } from "react-router-dom";
//import { API_BASE_URL } from "../config.ts";

const drawerWidth = 240;

const NavigationPage: React.FC = () => {
    const navigate = useNavigate();

    // Get user role from localStorage
    const roles: string[] = JSON.parse(localStorage.getItem("roles") || "[]");
    const isAdmin = roles.includes("admin");

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        navigate("/");
    };

    const menuItems = [
        {
            text: "Home", icon: <HomeIcon />, path: "/home" },
        {
            text: "Emails", icon: <EmailIcon />, path: "/emails"
        },
        {
            text: "Customers", icon: <PeopleIcon />, path: "/customers" },
        {
            text: "Contacts", icon: <ContactPhoneIcon />, path: "/contacts" },
        {
            text: "Orders", icon: <OrdersIcon />, path: "/orders"
        },
        {
            text: "Services", icon: <ServiceIcon />, path: "/services"
        },
        {
            text: "Types", icon: <OrderTypeIcon />, path: "/ordertypes"
        },
        {
            text: "States", icon: <OrderStateIcon />, path: "/orderstates"
        },

        {
            text: "Ignore List", icon: <DoNotDisturbOnIcon />, path: "/ignorelist"
        },
        (isAdmin ? { text: "Users", icon: <AdminPanelSettingsIcon />, path: "/users" } : {}),
        { text: "Logout", icon: <LogoutIcon />, action: handleLogout },
    ];

    return (
        <Box sx= {{ display: "flex" }
}>
    <CssBaseline />

{/* Top AppBar */ }
<AppBar
                position="fixed"
sx = {{
    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
    <Toolbar>
    <Typography variant="h6" noWrap component = "div" >
        DA Customs
            </Typography>
            </Toolbar>
            </AppBar>

{/* Side Drawer */ }
<Drawer
                variant="permanent"
sx = {{
    width: drawerWidth,
        flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
        width: drawerWidth,
            boxSizing: "border-box",
                    },
}}
            >
    <Toolbar />
        <Box sx={{ overflow: "auto" }}>
            <List>
                {menuItems
                    .filter((item) => item.text) // Filter out any undefined/empty items
                    .map((item, index) => (
                        <ListItem
                            key={index}
                            disablePadding
                            onClick={() =>
                                item.path ? navigate(item.path) : item.action?.()
                            }
                        >
                            <ListItemButton>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
            </List>
        </Box>
    </Drawer>

{/* Main Content */ }
<Box
                component="main"
sx = {{
    flexGrow: 1,
        bgcolor: "background.default",
            p: 3,
                ml: `${drawerWidth}px`,
                }}
            >
    <Toolbar />
    < Typography variant = "h4" gutterBottom >
        Welcome to the Tickets Page!
            </Typography>
            < Typography paragraph >
                This is where tickets will be listed. Use the menu on the left to navigate through the application.
                </Typography>
                    </Box>
                    </Box>
    );
};

export default NavigationPage;
